const formatNominal = (num) => {
  if (num >= 1_000_000_000_000) {
    return (num / 1_000_000_000_000)
      .toFixed(2)
      .replace(/\.00$/, '')
      .replace('.', ',') + ' T';
  } else if (num >= 1_000_000_000) {
    return (num / 1_000_000_000)
      .toFixed(2)
      .replace(/\.00$/, '')
      .replace('.', ',') + ' M';
  } else if (num >= 1_000_000) {
    return (num / 1_000_000)
      .toFixed(2)
      .replace(/\.00$/, '')
      .replace('.', ',') + ' Jt';
  } else if (num >= 1_000) {
    return (num / 1_000)
      .toFixed(2)
      .replace(/\.00$/, '')
      .replace('.', ',') + ' Rb';
  } else {
    return num.toString();
  }
};

export default formatNominal;
